// frontend/src/components/blog/reader/BlogList.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../../../components/AuthContext";
import axios from "axios";
import BlogPostCard from "../common/BlogPostCard";
import "./BlogList.css";

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");
  const { token } = useAuth();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/blog/posts?status=published`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        setPosts(response.data);
      } catch (err) {
        setError("Failed to load blog posts");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [token]);

  const filteredPosts =
    filter === "all" ? posts : posts.filter((post) => post.category === filter);

  if (loading) return <div className="blog-loading">Loading blog posts...</div>;
  if (error) return <div className="blog-error">{error}</div>;

  return (
    <div className="blog-list-container">
      <div className="blog-header">
        <h1>Blog</h1>
        <div className="blog-filters">
          <button
            className={filter === "all" ? "active" : ""}
            onClick={() => setFilter("all")}
          >
            All
          </button>
          <button
            className={filter === "wellness" ? "active" : ""}
            onClick={() => setFilter("wellness")}
          >
            Wellness
          </button>
          <button
            className={filter === "treatments" ? "active" : ""}
            onClick={() => setFilter("treatments")}
          >
            Treatments
          </button>
          <button
            className={filter === "announcements" ? "active" : ""}
            onClick={() => setFilter("announcements")}
          >
            Announcements
          </button>
          <button
            className={filter === "tips" ? "active" : ""}
            onClick={() => setFilter("tips")}
          >
            Tips & Advice
          </button>
        </div>
      </div>

      {filteredPosts.length === 0 ? (
        <div className="no-posts">No blog posts found</div>
      ) : (
        <div className="blog-posts-grid">
          {filteredPosts.map((post) => (
            <BlogPostCard key={post._id} post={post} />
          ))}
        </div>
      )}
    </div>
  );
};

export default BlogList;
